module.exports = __webpack_public_path__ + "img/no_address.0fe6b10b.svg";